import { PiTargetBg } from '../config/appConfig/appConfig.types';
import QuantumService from '../contexts/services/quantumService';
import { Maybe } from '../types/types.generated';
import { getErrorMessage, piErrToGraphQLErr } from '../utils/errorUtils';
import { IPiNxtAPIResponse } from '../types/pinxt';

interface IGraphqlFetcherRequest {
  /** PiNxt graphql endpoint   */
  endpoint: string;

  /** The token to access the PiNxt graphql endpoint with */
  accessToken: string;

  /** If on a Blue / Green env, designates which env to use */
  targetBg: PiTargetBg;

  /** The graphql query / mutation that's being requested */
  query: string;

  /** Any variables that go along with the GraphQL request */
  variables?: unknown;

  /** Additional Headers to pass with the request */
  additionalHeaders?: Record<string, string>;
}

/**
 * Make a GraphQL Request, try not to call this directly in the components
 * but instead attempt to use useGraphqlFetcher hook first.
 */
export const graphqlFetcher = async <T>({
  endpoint,
  accessToken,
  targetBg,
  query,
  additionalHeaders,
  variables,
}: IGraphqlFetcherRequest): Promise<T> => {
  const fetchStartMs = new Date().valueOf();

  let response: Maybe<Response> = null;
  try {
    response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        // Required for send user invitation API
        Accept: 'application/json',
        'X-DOMAIN-SESSION-IDENTITY': accessToken,
        target_bg: targetBg,
        ...(additionalHeaders || {}),
      },

      body: JSON.stringify({ query, variables }),
    });
  } catch (error) {
    QuantumService.apiGqlCall({
      fetchStartMs,
      response: null,
      query,
      endpoint,
      errorCode: 'unknown',
      errorMessage: getErrorMessage(error),
    });

    console.error(error);
    return Promise.reject(error);
  }

  QuantumService.apiGqlCall({
    fetchStartMs,
    response,
    query,
    endpoint,
  });

  const json = await response.json();
  const { errors, resultCode } = json;
  if (errors || resultCode) {
    return Promise.reject(
      resultCode ? piErrToGraphQLErr(json as IPiNxtAPIResponse) : errors
    );
  }

  return json.data;
};
